import { axios } from '@/api/axios.ts';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  TCreateSubAccount,
  TSubAccount,
  TSubAccountBehaviour,
  TSubAccountsParams,
  TUpdateSubAccount,
} from './sub-accounts.types.ts';

export const subAccountsApi = {
  getSubAccounts: async (params?: TSubAccountsParams) => {
    const response = await axios.get<TSubAccount[]>('profile/sub-accounts', { params });

    return response.data;
  },
  createSubAccount: async (data: TCreateSubAccount) => {
    const response = await axios.post<TSubAccount>('profile/sub-accounts', data);

    return response.data;
  },
  updateSubAccount: async (payload: { id: number; data: TUpdateSubAccount }) => {
    const { id, data } = payload;
    const response = await axios.patch<TSubAccount>(`profile/sub-accounts/${id}`, data);

    return response.data;
  },
  deleteSubAccount: async (payload: { id: number }) => {
    const { id } = payload;
    const response = await axios.delete<TSubAccount>(`profile/sub-accounts/${id}`);

    return response.data;
  },
  getBehaviours: async () => {
    const response = await axios.get<TSubAccountBehaviour[]>('profile/sub-accounts/behaviours');

    return response.data;
  },
};

export const subAccountsQueries = createQueryKeys('subAccounts', {
  getSubAccounts: (params?: TSubAccountsParams) => ({
    queryKey: ['list', params],
    queryFn: () => subAccountsApi.getSubAccounts(params),
  }),
  getBehaviours: () => ({
    queryKey: ['behaviours'],
    queryFn: () => subAccountsApi.getBehaviours(),
  }),
});
